import { generateUuid } from '../../../helpers/string';
import { ProductImage, ProductResource } from '../../@api/Sylius';
import { FormImageOption } from '../../@forms/Form/Form';
import { transformProductImageToMediaItem } from '../../Media/MediaTransformers';
import { ProductDefault } from './ProductDefault';

interface ProductDefaultOptions {
    images?: ProductImage[];
    variantID?: string;
    variants?: FormImageOption[];
}

export const transformToProductDefault = (resource: ProductResource, options: ProductDefaultOptions = {}): ProductDefault => {
    const { images = [], variants } = options;

    const id = resource.id
        ? resource.id.toString()
        : generateUuid();

    const name = resource.name || '';

    const mediaItems = images.map(image => transformProductImageToMediaItem(image, name));

    return {
        id,
        productCode: resource.code,
        slug: resource.slug || '',
        name,
        shortDescription: resource.shortDescription || '',
        mediaItems,
        variants,
    };
};

export const sortVariantsOptions = (variants: FormImageOption[], relativeUrl: string): FormImageOption[] => {
    const firstItem = variants.find(obj => obj.value === relativeUrl);
    const otherItems = variants.filter(obj => obj.value !== relativeUrl);

    return firstItem
        ? [firstItem, ...otherItems]
        : variants;
};
